export const calculatePercentage = (dividend: number, divisor: number): string =>
  new Intl.NumberFormat('en-US', { style: 'percent' }).format(dividend / divisor);
